import Vue from 'vue'
import Router from 'vue-router'
import Index from "@/views/home/Index";
import Main from "@/views/main/Index";
import Profile from "@/views/aboutCompany/profile";
import Qualifications from "@/views/aboutCompany/qualifications";
import SingleProduct from "@/views/productConter/single";
import ThreePaseProduct from "@/views/productConter/threePhase";
import KwhProduct from "@/views/productConter/kwh";
import MonitorProduct from "@/views/productConter/monitor";
import SingleProgramme from "@/views/programme/single";
import ThreePaseProgramme from "@/views/programme/threePhase";
import KwhProgramme from "@/views/programme/kwh";
import MonitorProgramme from "@/views/programme/monitor";
import Trade from "@/views/newList/trade";
import Company from "@/views/newList/company";
import NewEdit from "@/views/newList/edit";
import Contact from "@/views/contact/index";
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      meta: {
        title: "首页",
        keepAlive: true,
        header: true,
      },
      component: Index
    },
    {
      path: "/Main",
      name: "Main",
      meta: {
        title: "主页",
        keepAlive: true,
        header: true,
      },
      component: Index,
      component: Main
    },
    {
      path: "/Profile",
      name: "Profile",
      meta: {
        title: "公司简介",
        keepAlive: true,
        header: true,
      },
      component: Profile
    },
    {
      path: "/Qualifications",
      name: "Qualifications",
      meta: {
        title: "公司资质",
        keepAlive: true,
        header: true,
      },
      component: Qualifications
    },
    {
      path: "/SingleProduct",
      name: "SingleProduct",
      meta: {
        title: "单相重合闸系列",
        keepAlive: true,
        header: true,
      },
      component: SingleProduct
    },
    {
      path: "/ThreePaseProduct",
      name: "ThreePaseProduct",
      meta: {
        title: "三相重合闸系列",
        keepAlive: true,
        header: true,
      },
      component: ThreePaseProduct
    },
    {
      path: "/KwhProduct",
      name: "KwhProduct",
      meta: {
        title: "智慧用电管理终端",
        keepAlive: true,
        header: true,
      },
      component: KwhProduct
    },
    {
      path: "/MonitorProduct",
      name: "MonitorProduct",
      meta: {
        title: "智能监控系列",
        keepAlive: true,
        header: true,
      },
      component: MonitorProduct
    },
    {
      path: "/SingleProgramme",
      name: "SingleProgramme",
      meta: {
        title: "单相重合闸系列",
        keepAlive: true,
        header: true,
      },
      component: SingleProgramme
    },
    {
      path: "/ThreePaseProgramme",
      name: "ThreePaseProgramme",
      meta: {
        title: "三相重合闸系列",
        keepAlive: true,
        header: true,
      },
      component: ThreePaseProgramme
    },
    {
      path: "/KwhProgramme",
      name: "KwhProgramme",
      meta: {
        title: "智慧用电管理终端",
        keepAlive: true,
        header: true,
      },
      component: KwhProgramme
    },
    {
      path: "/MonitorProgramme",
      name: "MonitorProgramme",
      meta: {
        title: "智能监控系列",
        keepAlive: true,
        header: true,
      },
      component: MonitorProgramme
    },
    {
      path: "/Company",
      name: "Company",
      meta: {
        title: "公司资讯",
        keepAlive: true,
        header: true,
      },
      component: Company
    },
    {
      path: "/Trade",
      name: "Trade",
      meta: {
        title: "行业资讯",
        keepAlive: true,
        header: true,
      },
      component: Trade
    },
    {
      path: "/Contact",
      name: "Contact",
      meta: {
        title: "联系我们",
        keepAlive: true,
        header: true,
      },
      component: Contact
    },
    {
      path: "/NewEdit",
      name: "NewEdit",
      meta: {
        title: "资讯详情",
        keepAlive: true,
        header: true,
      },
      component: NewEdit
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js